import { getCurrentBasic } from './core/ProgramService'

/**
 *
 * @description 热门专题 浏览
 */
export async function reportHotTopicView(params: { hotTopicId: string; hotTopicTitle: string }) {
    window['sensors'].track(
        'KbPGCObjUserAct',
        Object.assign(await getCurrentBasic(), {
            business: 'HOT_TOPIC',
            businessVer: 1,
            pageName: '热门专题页',
            pageUrl: window.location.href,

            ref1Name: '热门专题',
            ref1: params.hotTopicId,
            ref1Title: params.hotTopicTitle,

            view: 1,
        }),
    )
}

/**
 *
 * @description 热门专题 发帖
 */
export async function reportHotTopicCreateNote(params: {
    hotTopicId: string

    hotTopicTitle: string

    /** 发帖的⽂字 */
    noteText?: string

    /** 发帖视频 */
    noteVideo?: unknown[]

    /** 发帖⾳频 */
    noteAudio?: unknown[]

    /** 发帖图⽚ */
    noteImage?: unknown[]
}) {
    window['sensors'].track(
        'KbPGCObjUserAct',
        Object.assign(await getCurrentBasic(), {
            business: 'HOT_TOPIC',
            businessVer: 1,
            pageName: '热门专题页',
            pageUrl: window.location.href,

            ref1Name: '热门专题',
            ref1: params.hotTopicId,
            ref1Title: params.hotTopicTitle,

            note: 1,
            reply: 1,

            noteText: params.noteText?.length ?? 0,
            noteVideo: params.noteVideo?.length ?? 0,
            noteAudio: params.noteAudio?.length ?? 0,
            noteImage: params.noteImage?.length ?? 0,
        }),
    )
}

/**
 *
 * @description 热门专题 评论
 */
export async function reportHotTopicComment(params: {
    hotTopicId: string

    hotTopicTitle: string

    /** 发帖的⽂字 */
    commentText?: string
}) {
    window['sensors'].track(
        'KbPGCObjUserAct',
        Object.assign(await getCurrentBasic(), {
            business: 'HOT_TOPIC',
            businessVer: 1,
            pageName: '热门专题页',
            pageUrl: window.location.href,

            ref1Name: '热门专题',
            ref1: params.hotTopicId,
            ref1Title: params.hotTopicTitle,

            reply: 1,
            comment: 1,

            commentText: params.commentText?.length ?? 0,
        }),
    )
}
